import addMenues_store from './components/addMenus.js'
import addRoutes_store from './components/addRoutes.js'
import websocket_tore from './components/websocketStore.js'
import public_data from './components/publicData.js'
import user from './components/user.js'

export default{
    menu:addMenues_store,
    route:addRoutes_store,
    socket:websocket_tore,
    data:public_data,
    user
}


// WEBPACK FOOTER //
// ./src/store/modules.js